module.exports = __webpack_public_path__ + "img/futuristic-technology.3e19a994.png";